import * as React from 'react';
import PropTypes from 'prop-types';

const SvgActionsVisibleDisabledNormalXsmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M14.64 6.12l-.91.48c.381.432.713.905.99 1.41a7.655 7.655 0 01-9.88 3.32l-1.08.57A8.541 8.541 0 008 13.01a8.591 8.591 0 007.73-4.77l.11-.23-.11-.22a8.42 8.42 0 00-1.09-1.67zM1.29 9.82l.9-.48a7.8 7.8 0 01-.91-1.33 7.608 7.608 0 016.72-4c1.045 0 2.079.21 3.04.62l1.09-.58A8.665 8.665 0 00.27 7.79l-.11.22.11.23a8.9 8.9 0 001.02 1.58z"
        fill=""
      />
      <path
        d="M5.01 7.84l1.15-.61a1.989 1.989 0 012.25-1.2l1.14-.61a3 3 0 00-4.54 2.42zm5.99.22l-1.11.58a1.989 1.989 0 01-2.41 1.29l-1.11.59A3 3 0 0011 8.06zm2.1-3.39L0 11.64v1.13l16-8.51V3.12l-2.9 1.55z"
        fill=""
      />
    </svg>
  )
);
SvgActionsVisibleDisabledNormalXsmall.defaultProps = {
  color: 'currentColor',
  size: 16,
  title: undefined,
  titleId: undefined
};
SvgActionsVisibleDisabledNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgActionsVisibleDisabledNormalXsmall;
